import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const Drag16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M12.6667 5.14286C12.6667 5.77404 13.189 6.28571 13.8333 6.28571C14.4777 6.28571 15 5.77404 15 5.14286C15 4.51167 14.4777 4 13.8333 4C13.189 4 12.6667 4.51167 12.6667 5.14286Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M12.6667 10.8571C12.6667 11.4883 13.189 12 13.8333 12C14.4777 12 15 11.4883 15 10.8571C15 10.226 14.4777 9.71429 13.8333 9.71429C13.189 9.71429 12.6667 10.226 12.6667 10.8571Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M8 12C7.35567 12 6.83333 11.4883 6.83333 10.8571C6.83333 10.226 7.35567 9.71429 8 9.71429C8.64433 9.71429 9.16667 10.226 9.16667 10.8571C9.16667 11.4883 8.64433 12 8 12Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M6.83333 5.14286C6.83333 5.77404 7.35567 6.28571 8 6.28571C8.64433 6.28571 9.16667 5.77404 9.16667 5.14286C9.16667 4.51167 8.64433 4 8 4C7.35567 4 6.83333 4.51167 6.83333 5.14286Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M2.16667 12C1.52233 12 1 11.4883 1 10.8571C1 10.226 1.52233 9.71429 2.16667 9.71429C2.811 9.71429 3.33333 10.226 3.33333 10.8571C3.33333 11.4883 2.811 12 2.16667 12Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M1 5.14286C1 5.77404 1.52233 6.28571 2.16667 6.28571C2.811 6.28571 3.33333 5.77404 3.33333 5.14286C3.33333 4.51167 2.811 4 2.16667 4C1.52233 4 1 4.51167 1 5.14286Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
